import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Toggle · Checkbox · Segmented — §4's controls.
 *
 * All three are React Aria's: the hidden input, the label association, the press and hover
 * handling and the `data-*` state flags are RAC's, and the box, the track and the knob are
 * still ours. `Segmented` is a `ToggleButtonGroup`, which makes the row **one** tab stop with
 * arrow keys inside it rather than three tab stops in a row.
 */
import { Checkbox as AriaCheckbox, Switch, ToggleButton, ToggleButtonGroup, } from 'react-aria-components';
import { TickGlyph } from '../glyphs.js';
export function Toggle({ label, checked, disabled, ...rest }) {
    return (_jsxs(Switch, { ...rest, className: "switch", isSelected: checked, isDisabled: disabled, children: [_jsx("span", { className: "track", "aria-hidden": "true", children: _jsx("span", { className: "knob" }) }), _jsx("span", { children: label })] }));
}
export function Checkbox({ label, checked, disabled, ...rest }) {
    return (_jsxs(AriaCheckbox, { ...rest, className: "check", isSelected: checked, isDisabled: disabled, children: [_jsx("span", { className: "box", "aria-hidden": "true", children: _jsx(TickGlyph, { className: "check-tick tick" }) }), _jsx("span", { children: label })] }));
}
/**
 * The Day/Night switch is the reference pattern, and the pressed state is still the visual.
 *
 * What changed with RAC is underneath it: a single-selection `ToggleButtonGroup` announces
 * itself as a **radio group**, not as a row of pressed buttons. That is the more honest
 * reading — exactly one of these is true at a time, and `aria-pressed` on three siblings
 * never said so — and it brings roving focus, so the row is one tab stop with arrow keys
 * inside it. `disallowEmptySelection` keeps it from ever having no answer.
 */
export function Segmented({ label, options, value, onChange, }) {
    return (_jsx(ToggleButtonGroup, { className: "seg", "aria-label": label, selectionMode: "single", disallowEmptySelection: true, selectedKeys: [value], onSelectionChange: (keys) => {
            const [first] = [...keys];
            if (first !== undefined)
                onChange(first);
        }, children: options.map((option) => (_jsx(ToggleButton, { id: option.value, className: "seg-btn", children: option.label }, option.value))) }));
}
//# sourceMappingURL=Controls.js.map